import { render, staticRenderFns } from "./VehiclePageOverview.vue?vue&type=template&id=2aa6e3a0&"
import script from "./VehiclePageOverview.vue?vue&type=script&lang=js&"
export * from "./VehiclePageOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports